import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Loader2 } from "lucide-react";
import { type PropsWithChildren, useState } from "react";

interface OtpConfirmationDialogProps extends PropsWithChildren {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  onSubmit?: (otp: string) => void;
  isLoading?: boolean;
}

export const OtpConfirmationDialog = ({
  open,
  onOpenChange,
  onSubmit,
  isLoading,
  children,
}: OtpConfirmationDialogProps) => {
  const [otp, setOtp] = useState("");

  const handleSubmit = () => {
    if (otp.length !== 6) return;

    onSubmit?.(otp);
  };

  return (
    <Dialog open={open} onOpenChange={isLoading ? undefined : onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Enter verification code</DialogTitle>
          <DialogDescription>
            Enter the 6-digit code from your authenticator app to continue.
          </DialogDescription>
        </DialogHeader>
        <div>{children}</div>
        <div className="flex justify-center py-4">
          <InputOTP maxLength={6} value={otp} onChange={setOtp} disabled={isLoading}>
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange?.(false)} disabled={isLoading}>
            Cancel
          </Button>

          <Button onClick={handleSubmit} disabled={otp.length !== 6 || isLoading}>
            {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isLoading ? "Verifying..." : "Verify"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
